import React, { useState } from "react";

type TextAreaProps = {
  value?: any;
  name?: string
  placeholder?: string;
  className?: string;
  onChange: any;
  onPressEnter?: any
  status?: 'error' | 'warning' | ''
  validationMessage?: string
  rows?: number;
};

const TextArea = (props: TextAreaProps) => {
  const [value, setValue] = useState(props.value || "");

  const handleOnChange = (e) => {
    setValue(e.target.value);
    props.onChange && props.onChange(e);
  };

  const handleEnterButton = (e) => {
    if (e.key === "Enter") {
      props.onPressEnter(e);
    }
  };
  return (
    <div className={`dataentry-container ${props.status}`}>
      <textarea
        rows={props.rows ? props.rows : 5}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => handleOnChange(e)}
        value={value}
        placeholder={props.placeholder}
        className={props.className}
        name={ props.name}
        onKeyDown={props.onPressEnter && handleEnterButton}
      ></textarea>
    </div>
  );
};

export default TextArea;
